// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__pzud1","menu__list":"styles_menu__list__ZXxWI","menu__item":"styles_menu__item__j02JY"};